import classNames from "classnames";
import React from "react";
import PropTypes from "prop-types";
import { getSubchapterImageSrc } from "../../lib/utils";
import styles from "../../styles/content.module.scss";

const SectionImage = ({ image, type }) => {
  const position = image.position;

  return (
    <div
      className={classNames(
        styles.sectionImage,
        styles[position],
        styles[type]
      )}
    >
      <img src={getSubchapterImageSrc(image)} alt="" />
    </div>
  );
};

SectionImage.propTypes = {
  image: PropTypes.shape({
    position: PropTypes.string.isRequired,
    illustration: PropTypes.string.isRequired,
    customSrc: PropTypes.string
  }).isRequired,
  type: PropTypes.oneOf(["circle", "normal"])
};

SectionImage.defaultProps = {
  type: "circle"
};

export default SectionImage;
